import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import type { OrganisationClient } from '~/api/clients/types';

import { LinkButton, Tooltip } from '~/components';
import { SearchParamKeys } from '~/constants/url';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { qs } from '~/utils/searchParams';

import { isClientEditable } from '../utils';
import { wrapperStyle } from './OrganisationActions.css';

type Props = {
  client: OrganisationClient;
};

export const OrganisationActions = ({ client }: Props) => {
  const [searchParams] = useSearchParams();

  const { t } = useTranslation(['clients', 'common']);

  if (!isClientEditable(client)) return null;

  return (
    <div className={wrapperStyle}>
      <Tooltip content={t('clients:detail.info.edit.action')}>
        <LinkButton
          aria-label={t('clients:detail.info.edit.action')}
          emphasis="tertiary"
          icon="Edit"
          to={{
            pathname: r(routes.editClient, { clientId: client.id }),
            search: qs({ [SearchParamKeys.REDIRECT_PATH]: searchParams.get(SearchParamKeys.REDIRECT_PATH) ?? undefined }),
          }}
        />
      </Tooltip>
    </div>
  );
};
